<div class="auth-container">
  <div class="auth-box">
    <h2>Reset Password</h2>
    <p class="subtitle">Enter your new password below</p>

    <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
      <!-- Password Field -->
      <div class="form-group">
        <label for="password">New Password</label>
        <div class="password-input-wrapper">
          <input
            type="{{ showPassword ? 'text' : 'password' }}"
            id="password"
            formControlName="password"
            placeholder="Enter new password"
            class="form-control"
            [class.is-invalid]="
              submitted && resetPasswordForm.get('password')?.invalid
            "
          />
          <button
            type="button"
            class="toggle-password"
            (click)="togglePasswordVisibility()"
          >
            <i [class]="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
          </button>
        </div>
        <small class="error" *ngIf="submitted && resetPasswordForm.get('password')?.errors?.required">
          Password is required
        </small>
        <small class="error" *ngIf="submitted && resetPasswordForm.get('password')?.errors?.minlength">
          Password must be at least 6 characters
        </small>
      </div>

      <!-- Confirm Password Field -->
      <div class="form-group">
        <label for="confirmPassword">Confirm Password</label>
        <div class="password-input-wrapper">
          <input
            type="{{ showConfirmPassword ? 'text' : 'password' }}"
            id="confirmPassword"
            formControlName="confirmPassword"
            placeholder="Confirm new password"
            class="form-control"
            [class.is-invalid]="
              submitted && resetPasswordForm.get('confirmPassword')?.invalid
            "
          />
          <button
            type="button"
            class="toggle-password"
            (click)="toggleConfirmPasswordVisibility()"
          >
            <i [class]="showConfirmPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
          </button>
        </div>
        <small class="error" *ngIf="submitted && resetPasswordForm.get('confirmPassword')?.errors?.required">
          Confirm password is required
        </small>
      </div>

      <!-- Submit Button -->
      <button
        type="submit"
        class="btn-submit"
        [disabled]="isLoading"
      >
        {{ isLoading ? 'Resetting...' : 'Reset Password' }}
      </button>
    </form>

    <!-- Back to Login -->
    <p class="back-to-login">
      Remember your password?
      <a routerLink="/login">Back to Login</a>
    </p>
  </div>
</div>
